import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const AnalyticsTracker = () => {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    // Initialize GA4 only once
    const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

    if (MEASUREMENT_ID && !initialized.current) {
      ReactGA.initialize(MEASUREMENT_ID);
      initialized.current = true;
    }

    if (initialized.current) {
      // Send pageview on route change
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;
